import { VendorProfileSettingsContainerRenderProps } from 'modules/portalConfigurations/types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import OcaLenderSettings from './OcaLenderSettings';

export default function OcaLenderSettingsCard({
  vpSettings,
  onSaveVendorProfile,
  loading,
}: VendorProfileSettingsContainerRenderProps) {
  return (
    <CardContainer title="OCA settings">
      <OcaLenderSettings vpSettings={vpSettings} onSaveVendorProfile={onSaveVendorProfile} loading={loading} />
    </CardContainer>
  );
}
